  // account faq
  // moving 
  document.addEventListener("DOMContentLoaded", function () {
      const links = document.querySelectorAll(".faq-scrollbar a");
      links.forEach(link => {
        link.addEventListener("click", function (event) {
          event.preventDefault();
    
          const targetId = this.getAttribute("href").substring(1);
          const targetElement = document.getElementById(targetId);
    
          if (targetElement) {
            window.scrollTo({
              top: targetElement.offsetTop - 130, 
              behavior: "smooth"
            });
          }
        });
      });
    });
    
    
    // on scroll make the list element as active 
    const divs = document.querySelectorAll('.faq-category');
    const allTags = document.querySelectorAll(".category-faqmedia");
    function checkDivPosition() {
      divs.forEach(div => {
        const rect = div.getBoundingClientRect();
        const threshold = window.innerHeight * 0.25; 
            if (rect.top <= threshold && rect.bottom >= 0) {
          let allTags = document.querySelectorAll(".category-faqmedia");
    
          allTags.forEach((item) => {
            item.classList.remove("active");
          });
    
          document.querySelector(`.${div.id}`).classList.add("active"); 
        }
      });
    } 
    function setFirstActive() {
      if (divs.length > 0) {
        allTags.forEach(item => item.classList.remove("active"));
        document.querySelector(`.${divs[0].id}`)?.classList.add("active");
      }
    }
    
      setFirstActive();
      checkDivPosition();
    window.addEventListener('scroll', checkDivPosition); 
   